import { useParams } from 'react-router'
import Box from '@cloudscape-design/components/box'
import SpaceBetween from '@cloudscape-design/components/space-between'
import Page from '@/components/common/Page'
import ConfigurePageComponent from '@/pages/clients/ClientConfigure/ConfigurePage'

export default function ConfigurePage() {
  const { clientId } = useParams<{ clientId: string }>()

  if (!clientId) return null

  return (
    <Page
      title="Settings"
      helpContent={{
        header: 'Agent Configuration',
        body: (
          <SpaceBetween size="m">
            <Box variant="p">
              Configure your agent's behavior and preferences. Provide business context so the agent generates more relevant content.
            </Box>
            <SpaceBetween size="xs">
              <Box variant="h4">Configuration Sections</Box>
              <SpaceBetween size="xxs">
                <Box><Box variant="strong">Business Info</Box> — Company name, brand details, and website URL. Use the <Box variant="strong">Fill from website</Box> button to automatically extract brand info, services, and contact details from your website.</Box>
                <Box><Box variant="strong">Online Presence</Box> — Google Business Profile location and social media profiles.</Box>
                <Box><Box variant="strong">Services</Box> — Products and services your business offers.</Box>
                <Box><Box variant="strong">Campaign Settings</Box> — Target audience, content types, and messaging tone.</Box>
                <Box><Box variant="strong">Schedule</Box> — Auto-generation frequency and timezone.</Box>
              </SpaceBetween>
            </SpaceBetween>
            <SpaceBetween size="xs">
              <Box variant="h4">Tips</Box>
              <Box variant="p">More detailed configuration leads to better generated content. Update regularly as your business needs change.</Box>
            </SpaceBetween>
          </SpaceBetween>
        ),
      }}
    >
      <ConfigurePageComponent />
    </Page>
  )
}
